import { ConsultancyLegalTypes } from './types';

export const getPosts = () => ({
  types: [
    ConsultancyLegalTypes.GET_DICAS_REQUEST,
    ConsultancyLegalTypes.GET_DICAS_SUCCESS,
    ConsultancyLegalTypes.GET_DICAS_FAILURE,
  ],
  promise: (client: any) => client.get('/consultoria_juridica/new'),
});

export const createDica = (mensagem: string) => ({
  types: [
    ConsultancyLegalTypes.GET_CREATE_REQUEST,
    ConsultancyLegalTypes.GET_CREATE_SUCCESS,
    ConsultancyLegalTypes.GET_CREATE_FAILURE,
  ],
  promise: (client: any) => client.post('/consultoria_juridica', { mensagem }),
});

export const posts = (id: string) => ({
  types: [
    ConsultancyLegalTypes.GET_POSTS_REQUEST,
    ConsultancyLegalTypes.GET_POSTS_SUCCESS,
    ConsultancyLegalTypes.GET_POSTS_FAILURE,
  ],
  promise: (client: any) => client.get(`/consultoria_juridica/posts/${id}`),
});
